import type { CybusDetailedService } from '../../../domain'

import { Usecase } from '..'

export class DownloadServiceUsecase extends Usecase {
    invoke (service: CybusDetailedService): void {
        this.fileService.download(this.connectwareServicesService.createFile(service))
    }
}
